import React from 'react';
import Chip from '@mui/material/Chip';
import type { CategoryChipsProps } from '../types';

const CategoryChips: React.FC<CategoryChipsProps> = ({
    categories,
    selectedCategory,
    onSelect,
    layout = 'scroll',
}) => {
    const rail = layout === 'rail';
    return (
        <div className={`posv2-categories ${rail ? 'posv2-categories--rail' : ''}`}>
            {categories.map((cat) => (
                <Chip
                    key={cat}
                    label={cat.split('-').join(' ')}
                    onClick={() => onSelect(cat)}
                    color={selectedCategory === cat ? 'primary' : 'default'}
                    variant={selectedCategory === cat ? 'filled' : 'outlined'}
                    className={`posv2-categories__chip ${rail ? 'posv2-categories__chip--rail' : ''}`}
                />
            ))}
        </div>
    );
};

export default React.memo(CategoryChips);
